import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { fontFamilies } from "../../constants";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 1)",
    boxShadow: theme.shadows[1],
    fontFamily: fontFamilies[500],
    fontSize: 10,
    fontWeight: 500,
    padding: "12px 14px",
    maxWidth: 240,
    border: "1px solid rgba(75, 100, 255, 0.1)",
    borderRadius: 12,
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

export default LightTooltip;
